import {LOGIN,LOGOUT,
    USERS, USER_DELETE, USER_CREATE, USER_UPDATE, PASSWORD_UPDATE, CREATE_TWO_FACTOR, DOWNLOAD_TWO_FACTOR, UPDATE_TWO_FACTOR_STATUS,
  } from '../constants/actionTypes';
  
  
export default (state = {pagination: { current: 1, pageSize: 10 }}, action) => {
  console.log(action.type, action)
  switch (action.type) {
    case LOGIN:
    case LOGOUT:
      return {  };
    case USER_CREATE:
    case USER_DELETE:
    case USER_UPDATE:
      return {
        ...state,
        statusCode: action.payload.status,
        message: action.payload.message,
        isLoadData: action.payload.status===200,
      };
    case USERS:
      delete state.message;
      delete state.statusCode;
      if (action.payload && action.payload.data){
        let user_data  = action.payload.data.users.map((value)=>{
          return {
            ...value,
            key: value.uuid, 
          }
        })
        return {
          ...state,
          users: user_data,
          isLoadData: false,
          redirectTo: action.payload.status===400?'/login':null
        };
      }
    default:
      return state;
  }
  };
  


// WEBPACK FOOTER //
// src/reducers/users.js